import Snap from './snap'
import SnapArrow from './guides/arrow'

/*
 * A snap type that snaps based on wob sizes. If wobA is being resized,
 * this will look at the other wobs on the canvas to see if any have a matching size (width/height)
 * and snap the resizing wob to match.
 */
const ElementSizeSnap = Snap.extend({

  getGuides: function (area, previousArea, handleType) {
    let guides = []

    if (this.handles.indexOf(handleType) === -1) {
      return guides
    }

    let areas = this.areas(area)
      , current = areas.shift()
      , prop = current[this.dimension]

    if (areas.length < 1) {
      // If we don't have other wobs to compare, we can exit early
      return guides
    }

    let closest = areas.reduce((p, c) => {
        // Find which wob is closest to our current dimension
        return Math.abs(c[this.dimension] - prop) < Math.abs(p[this.dimension] - prop) ? c : p
      })

    if (this.withinThreshold(prop - closest[this.dimension])) {
      let diff = (prop - closest[this.dimension]) * this.coordModifier(handleType)

      // Activate a size line on the current wob
      guides.push(new this.snapLine({direction: this.direction, canvas: this.canvas, from: closest[this.dimension], to: previousArea, diff}))

      // Now find all the wobs that have this identical property
      areas.filter(area => area[this.dimension] === closest[this.dimension])
           .forEach(area => {
             // Create a size line on each one
             guides.push(new this.snapLine({direction: this.direction, canvas: this.canvas, from: closest[this.dimension], to: area, diff}))
           })
    }

    return guides
  }

})


const HorizontalSnapArrow = SnapArrow.extend({

  type: 'horizontal',

  offset: 8, // How far away from the top of the wob to draw this line

  coords: function (width, area) {
    return {
      width: width,
      top: area.top + this.canvas.padding - this.offset,
      left: area.left + this.canvas.padding,
    }
  }

})

const VerticalSnapArrow = SnapArrow.extend({

  type: 'vertical',

  offset: 8, // How far away from the left side of the wob to draw this line

  coords: function (height, area) {
    return {
      height: height,
      top: area.top + this.canvas.padding,
      left: area.left + this.canvas.padding - this.offset,
    }
  }
})

const Width = ElementSizeSnap.extend({

  dimension: 'width',

  direction: 'left',

  handles: ['tl', 'tr', 'br', 'bl', 'lm', 'rm'], // Resize handlers supported by this snap type.

  snapLine: HorizontalSnapArrow,

  coordModifier: function (handle) {
    return (handle === 'rm' || handle === 'tr' || handle === 'br') ? -1 : 1
  }

})

const Height = ElementSizeSnap.extend({

  dimension: 'height',

  direction: 'top',

  handles: ['tl', 'tr', 'br', 'bl', 'tc', 'bc'], // Resize handlers supported by this snap type.

  snapLine: VerticalSnapArrow,

  coordModifier: function (handle) {
    return (handle === 'bc' || handle === 'bl' || handle === 'br') ? -1 : 1
  }

})

export {Width, Height}
